<template>
  <div class="modal-content">
    <div class="modal-body">
      <layout-details :baseDomain="baseDomain" :shopId="shopId" :apiKey="apiKey" :component="component" v-on:close="hideModal" v-on:save="save" v-on:unlinkLayout="unlinkLayout" />
    </div>
  </div>
</template>

<script>

import LayoutDetails from '~/components/LayoutDetails'

export default {
  props: ['baseDomain', 'shopId', 'apiKey', 'component'],
  methods: {
    hideModal () {
      this.$emit('close')
    },
    save (layout) {
      this.$emit('save', layout)
    },
    unlinkLayout (layout) {
      this.$emit('unlinkLayout', layout)
    }
  },
  components: {
    LayoutDetails
  }
}

</script>